import { TFilterKeys } from '../../types/filters';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActionType, TSetOpenedFilter } from './types';

export const setOpenedFilter: (filterKey?: TFilterKeys) => TSetOpenedFilter = actionGenerator<
  EFiltersActionType.SetOpenedFilter,
  TFilterKeys | undefined
>(EFiltersActionType.SetOpenedFilter);
